export const BASE_URL = import.meta.env.VITE_API_BASE_URL || "https://md-assistant.exactlylabs.com/api/v2";
